/**
 * The SelectEvent represents a selected state change caused by a user interaction.
 *
 * It's dispatched from components to notify listeners about the change when it's not set externally with component.selected = true/false.
 *
 * If the dispatching component wishes to send a piece of data along with the SelectEvent, it can use the generic payload property.
 */
export default class SelectEvent<Payload> extends Event {
	/**
	 * The static SELECTED_CHANGED property is used by the listeners, so we dont't get typo bugs.
	 *
	 * Example: addEventListener(SelectEvent.SELECTED_CHANGED, listener);
	 */
	public static SELECTED_CHANGED = 'SelectEvent.selectedChanged';
	/** The payload property can be used by the dispatching component if extra data needs to come along with the SelectEvent. */
	public payload: null | Payload;
	/** The selected property represents the dispatching components selected value. */
	public selected: boolean;

	public constructor(selected: boolean, payload: null | Payload = null) {
		super('SelectEvent.selectedChanged', { bubbles: true });
		assertIsBoolean(selected);
		this.payload = payload;
		this.selected = selected;
	}
}

function assertIsBoolean(value: unknown): asserts value is boolean {
	if (typeof value === 'boolean') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type boolean`);
}
